jQuery(document).ready(function ($) {

    //data
    const burger = document.querySelector(".c-header__hamburger");
    const navigation = document.querySelector(".nav");
    const liContact = document.querySelector('[data-index="contact"]');
    // const services = document.querySelector(".nav__services");
    const contact = document.querySelector(".s-contact__header");
    const contactHeader = document.querySelector(".c-header__contact");
    const navigationList = document.querySelectorAll(".nav__wrapper__left li");
    const navFooter = document.querySelector(".nav__footer");
    const main = document.querySelector("main");
    const openMenuContact = document.querySelectorAll(".open-menu-contact");
    const openBottomContact = document.querySelectorAll(".open-bottom-contact");
    const burgerAn = burger.firstChild.nextSibling;
    const allHeader = document.querySelector(".c-header");
    const hamburgerMenu = document.querySelector(".c-header__hamburger__lines");
    const logo = document.querySelector(".c-main-logo");
    allHeader.classList.add("c-header--open");
    const body = document.querySelector("body");


    //'contact us' btn whitch open contact form menu
    openMenuContact.forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            contactHeader.classList.add("hidden");
            allHeader.style.transform = "translateY(0)";
            burgerAn.classList.add("c-header__hamburger__lines--open");
            body.classList.add("overflow");

            setTimeout(() => {
                navigation.classList.add("nav__open");
                openContact();
            }, 500);
        });
    });

    //open bottom contact
    openBottomContact.forEach((element) => {
        element.addEventListener("click", () => {
            const contact = document.querySelector("#before-contact");
            window.scrollTo(0, contact.offsetTop, 600);
        });
    });

    // close menu on click next to menu
    document.querySelector("main").addEventListener("click", () => {
        if (navigation.classList.contains("nav__open")) {
            closeMenu();

        }
    });

    //open menu
    burger.addEventListener("click", () => {
        //close by arrow
        if (navigation.classList.contains("nav__open")) {
            closeMenu();

        } else {
            //open by hamburger
            document.removeEventListener("scroll", scrollHeader);


            body.classList.add("overflow");
            navigation.classList.toggle("nav__open");
            burgerAn.classList.add("c-header__hamburger__lines--open");
            contactHeader.classList.add("hidden");
            hamburgerMenu.classList.remove("background-black");
            burgerAn.classList.remove("background-black");
            logo.style.zIndex = '-99999';

        }
    });


    function openContact() {
        logo.style.zIndex = '-99999';

        contact.classList.add("visible");
        outlineElements();
        navFooter.classList.add("nav__footer--active");

        contact.classList.add("opacity");
        navigation.classList.add("nav__full");
        // services.classList.remove("visible");
        // services.classList.remove("opacity");
        setTimeout(() => {
            contact.classList.add("transformation-mobile");
        }, 100);
    }

    //outline for all liElements
    function outlineElements() {
        navigationList.forEach((el) => {
            el.classList.add("st-outline");
        });
    }

    //removing outline
    function outlineElementsReverse() {
        navigationList.forEach((el) => {
            el.classList.remove("st-outline");
        });
    }

    //hamburger animation
    burger.addEventListener("mouseover", () => {

        if (!burgerAn.classList.contains("c-header__hamburger__lines--open")) {
            burgerAn.classList.add("c-header__hamburger__lines--active");
        } else {
            burgerAn.classList.add("c-header__hamburger__lines--open--hover");
        }
    });
    burger.addEventListener("mouseout", () => {
        if (!burgerAn.classList.contains("c-header__hamburger__lines--open")) {
            burgerAn.classList.remove("c-header__hamburger__lines--active");
        } else {
            burgerAn.classList.remove("c-header__hamburger__lines--open--hover");
        }
    });

    //close Menu
    function closeMenu() {
        burgerAn.classList.remove("c-header__hamburger__lines--open");
        burgerAn.classList.remove("c-header__hamburger__lines--open--hover");
        logo.style.zIndex = '9999999';
        navFooter.classList.remove("nav__footer--active");
        navigation.classList.toggle("nav__open");
        navigation.classList.remove("nav__full");
        contact.classList.remove("nav__full");
        // services.classList.remove("visible");
        contact.classList.remove("visible");
        // services.classList.remove("transformation-mobile");
        contact.classList.remove("transformation-mobile");
        body.classList.remove("overflow");

        // closeForm();
        outlineElementsReverse();
        document.addEventListener("scroll", scrollHeader);
        setTimeout(() => {
            contactHeader.classList.remove("hidden");
        }, 400);
        /*if (!allHeader.classList.contains("headerBackground")) {
          contactHeader.classList.remove("hidden");
        }*/
        if ((window.scrollTop == 0) & main.classList.contains("case-study")) {
            burgerAn.classList.add("background-black");
            logo.classList.add("c-main-logo--dark");
        }
        if (allHeader.classList.contains('header--dark') && document.documentElement.scrollTop <= 10) {
            logo.classList.add('c-main-logo--dark');
            hamburgerMenu.classList.add('background-black');
        }
    }

    let oldValue = 0;
    let newValue = 0;
    let flag = 0;


    /* Always keep the header visible
     document.addEventListener("scroll", scrollHeader);*/

    function scrollHeader() {
        newValue = document.documentElement.scrollTop;

        if (oldValue < newValue && oldValue > 0) {
            if (flag === 0) {
                flag = 1;
                allHeader.classList.remove("headerBackground");
                /* Always keep the header visible
                allHeader.style.transform = "translateY(-100%)";*/
                setTimeout(() => {
                }, 4000);
                return;
            }
        } else if (oldValue > newValue) {
            if (flag === 1) {
                flag = 0;

                allHeader.classList.add("headerBackground");
                allHeader.style.transform = "translateY(0)";
                return;
            }
        }
        oldValue = newValue;
        return;
    }

});
